import Class from '../class.js';
import staticMembers from './_staticmembers.js';
import instanceMembers from './_prototype.js';
import initMK from '../_core/init.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
instanceMembers.constructor = function Matreshka() {
  if (!(this instanceof Matreshka)) {
    throw matreshkaError('common:call_class');
  }
  initMK(this);
};
var Matreshka = Class(instanceMembers, staticMembers);
// the value and the instance type under one name
export { Matreshka as default };